export const webBottomTabNavigationVisible = [false]
